module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.resumeInfo) ? _c('div', {
    staticClass: "resumeinfo-main",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "resume-download"
  }, [(_vm.resumeInfo.workerInfo.phone.includes('****')) ? _c('img', {
    staticClass: "addimg",
    attrs: {
      "src": require("../../assets/images/add.png")
    },
    on: {
      "click": _vm.downloadResume
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/addhad.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "resumeinfo",
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "reinfo-t"
  }, [_c('div', {
    staticClass: "reinfo-face"
  }, [(_vm.resumeInfo.workerInfo.headImage) ? _c('img', {
    attrs: {
      "src": _vm.resumeInfo.workerInfo.headImage
    }
  }) : _c('img', {
    attrs: {
      "src": "//oss.51ztx.com/resu.png"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "names"
  }, [_vm._v(_vm._s(_vm.resumeInfo.workerInfo.name))]), _vm._v(" "), _c('ul', {
    staticClass: "reinfo-spec"
  }, [_c('li', [_vm._v(_vm._s(_vm._f("sex")(_vm.resumeInfo.workerInfo.sex)))]), _vm._v(" "), (_vm.resumeInfo.workerInfo.age) ? _c('li', [_vm._v(_vm._s(_vm.resumeInfo.workerInfo.age) + "岁")]) : _vm._e(), _vm._v(" "), (_vm.resumeInfo.workerInfo.education) ? _c('li', [_vm._v(_vm._s(_vm.resumeInfo.workerInfo.education))]) : _vm._e(), _vm._v(" "), (_vm.resumeInfo.workerInfo.homeProvincenamels) ? _c('li', [_vm._v("\n                        " + _vm._s(_vm.resumeInfo.workerInfo.homeProvincename) + _vm._s(_vm.resumeInfo.workerInfo.homeCityname) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "rephone"
  }, [_c('i', {
    staticClass: "iconfont icon-call_ico"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.resumeInfo.workerInfo.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "readdress"
  }, [_c('i', {
    staticClass: "iconfont icon-loction_ico"
  }), _vm._v(" "), (_vm.resumeInfo.workerInfo.address) ? _c('span', [_vm._v(_vm._s(_vm.resumeInfo.workerInfo.address))]) : _c('span', {
    staticStyle: {
      "color": "#ccc"
    }
  }, [_vm._v("暂无地址详情信息")])])]), _vm._v(" "), (_vm.resumeInfo.workerInfo.phone.includes('****')) ? _c('div', {
    staticClass: "redown",
    staticStyle: {
      "padding-bottom": "30px"
    }
  }, [_c('span', {
    on: {
      "click": _vm.downloadResume
    }
  }, [_vm._v("下载简历")]), _vm._v("即可获得联系方式")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "reinfo-pub"
  }, [_c('div', {
    staticClass: "reinfo-pub-tit"
  }, [_vm._v("工作经历")]), _vm._v(" "), _c('div', {
    staticClass: "exp-listsbox"
  }, [(_vm.resumeInfo.expList.length > 0) ? _c('ul', {
    staticClass: "exp-list"
  }, _vm._l((_vm.resumeInfo.expList), function(item) {
    return _c('li', {
      staticClass: "exp-li"
    }, [_c('div', {
      staticClass: "exp-time"
    }, [_vm._v("\n                                " + _vm._s(item.inTime.split(" ")[0]) + " ~ " + _vm._s(item.outTime.split(" ")[0]) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "exp-tit"
    }, [_c('h4', {
      staticClass: "exp-h6"
    }, [_vm._v(_vm._s(item.companyName))]), _vm._v(" "), _c('p', [_vm._v("（" + _vm._s(item.positionName) + "）")])]), _vm._v(" "), _c('div', {
      staticClass: "exp-workcon"
    }, [_c('div', [_vm._v("工作内容：")]), _vm._v(" "), _c('p', {
      staticStyle: {
        "width": "568px"
      }
    }, [_vm._v(_vm._s(item.workDesc))])])])
  })) : _c('div', {
    staticStyle: {
      "color": "#666",
      "margin-left": "25px"
    }
  }, [_vm._v("\n                        暂无工作经历\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "reinfo-pub"
  }, [_c('div', {
    staticClass: "reinfo-pub-tit"
  }, [_vm._v("期望工作")]), _vm._v(" "), _vm._l((_vm.resumeInfo.ecpList), function(item, index) {
    return _c('dl', {
      staticClass: "expect-list"
    }, [_c('dd', {
      staticClass: "expect-firli"
    }, [_c('i', {
      staticClass: "iconfont icon-career_ico"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.positionName))])]), _vm._v(" "), _c('dd', [_c('i', {
      staticClass: "iconfont icon-loction_ico"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.cityName))])]), _vm._v(" "), _c('dd', [_c('i', {
      staticClass: "iconfont icon-money_ico1"
    }), _vm._v(" "), (item.minSalary == item.maxSalary) ? _c('span', {
      staticClass: "reinfo-money"
    }, [_vm._v("￥" + _vm._s(item.maxSalary))]) : _c('span', [_vm._v("￥" + _vm._s(item.minSalary) + "-" + _vm._s(item.maxSalary))])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resumeInfo.ecpList.length == 0),
      expression: "resumeInfo.ecpList.length == 0"
    }],
    staticStyle: {
      "color": "#666",
      "margin-left": "25px",
      "margin-top": "20px"
    }
  }, [_vm._v("\n                    暂无期望工作\n                ")])], 2), _vm._v(" "), (_vm.resumeInfo.workerInfo.brief) ? _c('div', {
    staticClass: "reinfo-pub"
  }, [_c('div', {
    staticClass: "reinfo-pub-tit"
  }, [_vm._v("自我描述")]), _vm._v(" "), (_vm.resumeInfo.workerInfo.brief) ? _c('div', {
    staticClass: "reinfo-selfintr"
  }, _vm._l((_vm.resumeInfo.workerInfo.brief.split('\n')), function(item) {
    return _c('p', [_vm._v(_vm._s(item))])
  })) : _c('div', {
    staticClass: "reinfo-selfintr"
  }, [_vm._v("暂无自我描述")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('confirmLayer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddResume),
      expression: "showAddResume"
    }],
    attrs: {
      "id": _vm.addResumeId,
      "name": _vm.addResumeName,
      "close": _vm.hideAddResume
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77ff860c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resume/seeinfo.vue
// module id = 896
// module chunks = 1